import { FaSpinner, FaExclamationTriangle } from "react-icons/fa";

const DataTable = ({
    columns,
    rows = [],
    totalRow,
    emptyMessage = "No data available",
    loading = false,
    error = null,
    onRowClick,
    rowKey,
    maxH = false
}) => (
    <div className={`overflow-auto tiny-scrollbar rounded-md border border-gray-100 ${maxH ? "max-h-[600px]" : ""}`}>
        <table className="w-full text-sm text-center">
            <thead className="bg-gray-100 sticky top-0 z-10">
                <tr>
                    {columns.map((col) => (
                        <th
                            key={col.key}
                            className="px-3 py-2.5 text-xs font-semibold uppercase tracking-widest text-gray-700 whitespace-nowrap"
                        >
                            {col.label}
                        </th>
                    ))}
                </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
                {loading ? (
                    <tr>
                        <td colSpan={columns.length} className="px-3 py-6 text-center text-gray-500">
                            <FaSpinner className="inline animate-spin mr-2" />
                            Loading...
                        </td>
                    </tr>
                ) : error ? (
                    <tr>
                        <td colSpan={columns.length} className="px-3 py-6 text-center text-red-600">
                            <FaExclamationTriangle className="inline mr-2" />
                            {error}
                        </td>
                    </tr>
                ) : rows.length === 0 ? (
                    <tr>
                        <td colSpan={columns.length} className="px-3 py-6 text-center text-gray-500">
                            {emptyMessage}
                        </td>
                    </tr>
                ) : (
                    <>
                        {/* {rows.map((row, i) => (
                            <tr
                                key={rowKey ? rowKey(row, i) : i}
                                onClick={onRowClick ? () => onRowClick(row) : undefined}
                                className={`hover:bg-gray-50 transition ${onRowClick ? "cursor-pointer" : ""}`}
                            >
                                {columns.map((col) => (
                                    <td key={col.key} className="px-3 py-2 whitespace-nowrap text-gray-600 font-medium">
                                        {col.render ? col.render(row) : row[col.key]}
                                    </td>
                                ))}
                            </tr>
                        ))} */}
                        {rows.map((row, i) => (
                            <tr
                                key={rowKey ? rowKey(row, i) : i}
                                onClick={onRowClick ? () => onRowClick(row) : undefined}
                                className={`hover:bg-gray-50 transition ${onRowClick ? "cursor-pointer" : ""}`}
                            >
                                {columns.map((col) => {
                                    const value = col.render ? col.render(row) : row[col.key];
                                    return (
                                        <td key={col.key} className="px-3 py-2 whitespace-nowrap text-gray-600 font-medium">
                                            {value === null || value === undefined || value === "" ? "-" : value}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                        {totalRow && (
                            <tr className="font-semibold bg-gray-100">
                                {totalRow.map((cell, i) => (
                                    <td key={i} className="px-3 py-2 whitespace-nowrap text-gray-700 font-medium">
                                        {cell}
                                    </td>
                                ))}
                            </tr>
                        )}
                    </>
                )}
            </tbody>
        </table>
    </div>
);

export default DataTable;